<div class="tabbable__body margin--none clearfix shadow-z-1">
  <div class="grid-container">
    <inventory-weeks-picker class="grid-item" (weeksChanged)="weeksChanged($event)"></inventory-weeks-picker>
    <div>
      <button
        id="exportButton"
        type="button"
        (click)="export()"
        class="button secondary"
      >
        Exportera lager
      </button>
    </div>
  </div>
  <form (ngSubmit)="filter()" id="inventory-form">
    <p>
      <span class="icon-warning text--info"></span>
      Om du inte filtrerar publicister motsvarar siffrorna hela WOO:s lager.
      Alla kombinationer nedan är inte säljbara, se
      <a class="text--info" href="/#/pricelist" target="_blank">prislistan</a>
      för möjliga kombinationer.
    </p>

    <div class="row">
      <div class="loader">
        <dot-loader [visibility]="fetchingFilters" description="Laddar filter"></dot-loader>
      </div>

      <div class="flex__container">
        @for (filterOption of filterOptions; track $index) {
          <inventory-filter
          class="col-sm-4 col-6 inventory-filter"
          [filterOption]="filterOption"
          (onChange)="filters[filterOption.filter_key] = $event.newValue"
          >
          </inventory-filter>
        }
      </div>
    </div>

    <button class="button primary-1" type="submit" [disabled]="fetchingData">
      Hämta lager
    </button>
    <button class="link primary-1" type="button" (click)="clearFilters()">
      Rensa filter
    </button>
  </form>

  <div id="inventory-result">
    @if (fetchingData) {
      <div class="block">
        <dot-loader [visibility]="fetchingData" description="Hämtar lager" [large]="false"></dot-loader>
      </div>
    }

    @if (inventoryTree) {
      <div class="margin-top--3x">
        @if (showViewCurrencyToggle) {
        <button class="link primary-1" type="button" (click)="toggleViewCurrency()">
          {{ toggleViewCurrencyLabel }}
        </button>
        }
      </div>

      <div class="text--gray float-end">
        <p class="text--small">
          <span class="icon-refresh"></span> Lagret hämtades
          {{ timeStamp | date:"d MMMM yyyy 'kl.'H.mm" }}
        </p>
      </div>

      <div class="text--gray float-start">
        <p class="text--small">
          {{ breadcrumb }}
        </p>
      </div>

      <div class="clearfix"></div>

      @if (!fetchingData) {
        <inventory-visualization
        [inventoryTree]="inventoryTree"
        [filterOptions]="filterOptions"
        [columnNames]="columnNames"
        [showTooltip]="warnForWithdrawalLimit"
        [viewCurrencyLabel]="viewCurrencyLabel(presentationCurrency)"
        >
        </inventory-visualization>
      }
    }
  </div>
</div>
